var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from '@/libs/axios';
var RolService = /** @class */ (function () {
    function RolService() {
        this.baseUrl = "/roles";
    }
    /**
     * Obtiene todos los roles
     */
    RolService.prototype.getAllRoles = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_1;
            var _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 2, , 3]);
                        console.log('🔍 Intentando obtener roles desde:', this.baseUrl);
                        return [4 /*yield*/, axios.get(this.baseUrl)];
                    case 1:
                        response = _g.sent();
                        console.log('✅ Roles obtenidos exitosamente:', response.data);
                        return [2 /*return*/, response.data];
                    case 2:
                        error_1 = _g.sent();
                        console.error('❌ Error al obtener roles:', error_1);
                        console.error('📊 Detalles del error:', {
                            status: (_a = error_1.response) === null || _a === void 0 ? void 0 : _a.status,
                            statusText: (_b = error_1.response) === null || _b === void 0 ? void 0 : _b.statusText,
                            data: (_c = error_1.response) === null || _c === void 0 ? void 0 : _c.data,
                            url: (_d = error_1.config) === null || _d === void 0 ? void 0 : _d.url,
                            method: (_e = error_1.config) === null || _e === void 0 ? void 0 : _e.method
                        });
                        // Si es un error 404, devolver lista vacía en lugar de lanzar error
                        if (((_f = error_1.response) === null || _f === void 0 ? void 0 : _f.status) === 404) {
                            console.log('⚠️ Endpoint de roles no encontrado, devolviendo lista vacía');
                            return [2 /*return*/, []];
                        }
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Obtiene un rol por ID
     */
    RolService.prototype.getRolById = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get("".concat(this.baseUrl, "/").concat(id))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_2 = _a.sent();
                        console.error("Error al obtener rol con ID ".concat(id, ":"), error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Obtiene un rol por nombre
     */
    RolService.prototype.getRolByNombre = function (nombre) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get("".concat(this.baseUrl, "/nombre/").concat(nombre))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_3 = _a.sent();
                        console.error("Error al obtener rol con nombre ".concat(nombre, ":"), error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return RolService;
}());
export default new RolService();
